<template>
  <div
      :class="'is-' + tone"
      class="lp-info-banner"
      role="status">
    <icon
        v-if="icon"
        :name="icon"
        class="lp-info-banner__icon"/>
    <span class="lp-info-banner__text">
      <slot/>
    </span>
    <slot name="action"/>
  </div>
</template>

<script>
export default {
  name:  'InfoBanner',
  props: {
    tone: {
      type:      String,
      default:   'info',
      validator: value => ['info', 'warn', 'neutral'].indexOf(value) !== -1,
    },
    icon: { type: String, default: '' },
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/lp-tokens';

.lp-info-banner {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  border-radius: $lp-radius-control;
  font-family: $lp-sans;
  font-size: $lp-fs-control;
  line-height: 18px;

  &.is-info {
    background: $lp-accent-soft;
    color: $lp-accent-ink;
  }

  &.is-warn {
    background: $lp-warn-bg;
    color: #8A5A00;
  }

  &.is-neutral {
    background: $lp-fill;
    color: $lp-muted;
  }
}

.lp-info-banner__icon {
  flex: 0 0 auto;
  min-width: 0;
  min-height: 0;
}

.lp-info-banner__text {
  flex: 1 1 auto;
  min-width: 0;
}
</style>
